import type { ComponentSchema } from '../../../../../schema-types'

/** Cream band, then up to 4 books on a shelf with price, writer, format, publisher and book details side by side. */
export const schema: ComponentSchema = {
  type: 'compare',
  label: 'Compare',
  description: 'Up to four saved books side by side (covers, price, writer, format, publisher, book details), or an empty state.',
  supportedPages: ['compare'],
  variants: [{ id: 'v1', label: 'Side by side' }],
  commonFields: [
    { key: 'title', label: 'Title', type: 'string', default: 'Compare products' },
    { key: 'emptyTitle', label: 'Empty title', type: 'string' },
    { key: 'emptyText', label: 'Empty message', type: 'string' },
  ],
}
